import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText, Select, CheckBox } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  agent_roles: any
  user: any
}

const FIELDS = {
  name: 'name',
  email: 'email',
  password: 'password',
  password_confirmation: 'password_confirmation',
  agent_role_id: 'agent_role_id',
  is_active: 'is_active',
}

const AgentMembersNew: React.FC<IProps> = props => {
  const { data: roles } = props.agent_roles
    ? agentService.getDataFromJson(props.agent_roles)
    : { data: [] }
  const roleOptions = [
    { value: '', label: I18n.t('generic.not_selected') },
    ...roles.map(r => ({ value: String(r.id), label: r.name })),
  ]

  const handleSubmit = React.useCallback(async (initialValues, values) => {
    if (values.password.length < 12) {
      window.flashMessages.addMessage({ text: I18n.t('generic.password_too_short'), type: 'error' })
      return
    }
    if (values.password !== values.password_confirmation) {
      window.flashMessages.addMessage({ text: I18n.t('generic.password_mismatch'), type: 'error' })
      return
    }
    try {
      const { flush } = await agentService.createAgentMember(values)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/agent_members'
    } catch (e) {
      // 403等はhttpClientインターセプターでモーダル表示済み
    }
  }, [])

  return (
    <AgentLayoutNew
      model="agent_members"
      title={`${I18n.t('generic.agent_members')} - ${I18n.t('generic.create_new')}`}
      fields={FIELDS}
      indexLink="/agent/agent_members"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText required={true} name="email" defaultValue="" label={I18n.t('generic.email')} />
          <InputText
            required={true}
            password={true}
            name="password"
            defaultValue=""
            label={I18n.t('generic.password')}
          />
          <InputText
            required={true}
            password={true}
            name="password_confirmation"
            defaultValue=""
            label={I18n.t('generic.password_confirm')}
          />
          <Select
            required={true}
            name="agent_role_id"
            defaultValue=""
            label={I18n.t('generic.agent_roles')}
            options={roleOptions}
          />
          <CheckBox name="is_active" defaultChecked={true} label={I18n.t('generic.active')} />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentMembersNew
